import React from "react";
import { Box, Typography, Button } from "@mui/material";

const ErrorScreen = ({ error }) => {
  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <Typography variant="h4" sx={{ color: "text.primary" }}>
        {error}
      </Typography>
      <Button
        variant="contained"
        onClick={() => (window.location.href = "https://fadepilot.com")}
      >
        Go to FadePilot
      </Button>
    </Box>
  );
};

export default ErrorScreen;
